module.exports = __webpack_public_path__ + "img/charity_easter_flower.692beeae.png";